module.exports = __webpack_public_path__ + "media/customizations/regencyathollysprings/back-97042b5fd8580f3661f2ecaf07ce54a8.jpg";